import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getFileThumbnail } from '../../services';

import FiletypeIcon from '../FiletypeIcon';
import { checkIsOnline } from '../../bundles/notifications';

const FileThumbnail = ({
  file,
  online,
  iconSize = 'l',
  loaded = () => {
    // do something on loaded
  },
}) => {
  const dispatch = useDispatch();
  const [thumbnailError, setThumbnailError] = useState(false);
  const [imgSource, setImgSource] = useState(null);
  const { shouldHaveThumbnail } = file;

  useEffect(() => {
    if (online) {
      setThumbnailError(false);
    }
  }, [online]);

  useEffect(() => {
    if (!shouldHaveThumbnail || thumbnailError) {
      loaded();
    }
  }, [thumbnailError, shouldHaveThumbnail]);

  useEffect(() => {
    setImgSource(null);
  }, [file.id]);

  useEffect(() => {
    let revokeUrl;
    let isMounted = true;
    async function fetchThumbnail() {
      try {
        const blob = await getFileThumbnail(file.id);
        const objectUrl = URL.createObjectURL(blob);
        if (isMounted) {
          setImgSource(objectUrl);
          revokeUrl = objectUrl;
        }
      } catch (error) {
        if (isMounted) {
          console.error('Error fetching thumbnail:', error);
          setThumbnailError(true);
          dispatch(checkIsOnline());
        }
      }
    }
    if (!thumbnailError && shouldHaveThumbnail) {
      fetchThumbnail();
    }
    return () => {
      isMounted = false;
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [file.id, shouldHaveThumbnail, thumbnailError, dispatch]);

  const handleImgError = () => {
    setThumbnailError(true);
    dispatch(checkIsOnline());
  };

  if (!thumbnailError && shouldHaveThumbnail && imgSource) {
    return (
      <img
        src={imgSource}
        alt={file.filename || file.name || 'File thumbnail'}
        onLoad={loaded}
        onError={handleImgError}
      />
    );
  }

  return (
    <FiletypeIcon
      size={iconSize}
      file={file}
    />
  );
};

export default FileThumbnail;
